import { TAvailableConfigValues } from '@customTypes/common';

export interface IResolutionManagerConfig {
  initialResolutionWidth?: number;
  initialResolutionHeight?: number;
  initialResolutionBitrate?: number;
  initialResolutionBitrateThreshold: number;
  autoloadLowestResolution: boolean;
  maxPlaylistTimeDifference: number;
  awaitForSegmentEndToSwitch: boolean;
  awaitForSegmentEndToSwitchManual: boolean;
  recreateSourceBufferOnResolutionChange: boolean;
  useFallbackResolutionIfResolutionNotFound: boolean;
}

export const defaultResolutionManagerConfig: IResolutionManagerConfig = {
  autoloadLowestResolution: true,
  initialResolutionWidth: 0,
  initialResolutionHeight: 720,
  initialResolutionBitrate: 0,
  initialResolutionBitrateThreshold: 100000,
  maxPlaylistTimeDifference: 40000,
  awaitForSegmentEndToSwitch: true,
  awaitForSegmentEndToSwitchManual: false,
  recreateSourceBufferOnResolutionChange: false,
  useFallbackResolutionIfResolutionNotFound: true,
};

export const availableResolutionManagerConfigValues: TAvailableConfigValues<IResolutionManagerConfig> = {};
